<template>
  <div class="home">
    <b-container>
      <PlayerPage class="marginal" ></PlayerPage>
    </b-container>
  </div>
</template>

<script>
import PlayerPage from '@/components/PlayerPage.vue';
export default {
  name: 'player',
  components: {
    PlayerPage
  }
}
</script>